import React, { useEffect } from "react";
import { data } from "../projectData/projectData.js";
import { useSpring, animated } from "react-spring";

const Work = () => {
  const project = data;
  const [isVisible, setVisible] = React.useState(false);
  const [animationComplete, setAnimationComplete] = React.useState(false);

  const springProps = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateX(0%)" : "translateX(100%)",
    config: { duration: 1200 },
    onRest: () => {
      setAnimationComplete(true);
    },
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const skillsSection = document.getElementById("work");
    const triggerPosition = skillsSection.offsetTop - window.innerHeight / 2;
    setVisible(animationComplete || scrollPosition > triggerPosition);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [animationComplete]);
  return (
    <section
      name="work"
      id="work"
      className="flex items-center w-full min-h-screen bg-gradient-to-tr from-[#0F172A] to-[#183250] text-slate-50 pt-20 sm:pt-6"
    >
      <div className="w-full md:max-w-[1000px] mx-auto md:p-6 h-full flex flex-col justify-center">
        <div className="pb-8">
          <animated.p
            style={springProps}
            className="mx-auto text-4xl text-center border-b-4 border-yellow-500 w-fit sm:text-5xl"
          >
            Work
          </animated.p>
        </div>

        <div className="grid md:px-4 md:grid-cols-3 md:gap-y-0">
          {project.map((item, index) => (
            <div
              key={index}
              className="container w-full my-2 px-4 md:px-0 md:my-0 relative flex content-div  group md:shadow-lg shadow-[#040c16] overflow-hidden md:h-[200px] h-[240px]"
            >
              <div
                className="w-[900px] h-full duration-300 sm:duration-500 opacity-1 group-hover:opacity-0 group-activate:opacity-0"
                style={{
                  backgroundImage: `url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="absolute top-0 left-0 w-full opacity-0 duration:300 sm:duration-500 group-hover:translate-y-10 group-activate:translate-y-10 group-hover:opacity-100">
                <div className="mx-auto text-2xl font-bold tracking-wider text-white w-fit">
                  {item.name}
                </div>
                <div className="pt-16 text-center sm:pt-8">
                  <a href={item.github} target="_blank" rel="noreferrer">
                    <button className="px-6 m-2 text-lg text-gray-700 bg-white ">
                      CODE
                    </button>
                  </a>
                  <a href={item.live} target="_blank">
                    <button className="px-6 m-2 text-lg text-gray-700 bg-white">
                      LIVE
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
